exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".color-selector[data-v-40e39654]{display:block!important}.color-container[data-v-40e39654] .flex{-ms-flex:1 1 auto;flex:1 1 auto}.color[data-v-40e39654]{box-sizing:border-box;width:36px;height:36px;border-radius:18px;margin:5px}.color.blank[data-v-40e39654]{background:linear-gradient(135deg,#fff,#fff 39%,red 40%,red 50%,red 60%,#fff 61%,#fff);border:5px solid red}.color.selected[data-v-40e39654]{border:5px solid #000!important}.color.small[data-v-40e39654]{width:25px!important;height:25px!important;padding:5px 8px!important}.color.small.selected[data-v-40e39654]{border:3px solid #000!important}.color.small.blank[data-v-40e39654]{border:4px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-40e39654","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/ColorPicker.vue
// module id = 1032
// module chunks = 22